import { useEffect, useSyncExternalStore } from 'react';

// O título da tela de cima também alimenta as migalhas do console da Área Resulti ("Operação ›
// Lojas › PC-000123"): uma pilha, porque uma janela por cima da tela tem o próprio título e, ao
// fechar, o da tela volta.
let pilha: string[] = [];
const ouvintes = new Set<() => void>();
const avisar = (): void => ouvintes.forEach((f) => f());

/**
 * Título da aba do navegador: "Instalações · PlugChef Admin". Ao sair (a janela de um produto que
 * fecha por cima da tela), volta o título de antes — senão a aba ficaria com o nome do item fechado.
 */
export function useTitulo(titulo: string | null | undefined): void {
  useEffect(() => {
    if (titulo === null) return;
    const antes = document.title;
    document.title = titulo ? `${titulo} · PlugChef Admin` : 'PlugChef Admin';
    const meu = titulo ?? '';
    pilha = [...pilha, meu];
    avisar();
    return () => {
      document.title = antes;
      const i = pilha.lastIndexOf(meu);
      pilha = i >= 0 ? [...pilha.slice(0, i), ...pilha.slice(i + 1)] : pilha;
      avisar();
    };
  }, [titulo]);
}

/** O título da tela (ou janela) de cima, para as migalhas. '' enquanto nenhuma tela publicou. */
export function useTituloAtual(): string {
  return useSyncExternalStore(
    (f) => {
      ouvintes.add(f);
      return () => {
        ouvintes.delete(f);
      };
    },
    () => pilha[pilha.length - 1] ?? '',
    () => '',
  );
}
